import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import { IGrade } from './grade';
import { IGradeFormValues } from './gradeFormValues';
import { IGradeUpsert } from './gradeUpsert';
import OptionType from '../../optionType';

export default class GradeModelHelper {
    public static createFormValues = (
        grade : IGrade | null,
        commodities : Array<ICommodity>,
        defaultCommodity : ICommodity | null
    ) : IGradeFormValues => {
        if (!grade) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            commodities: defaultCommodity
                ? [OptionType.fromDataModel(defaultCommodity)]
                : [],
            isActive: true,
        };

        const commoditiesOptions = commodities
            .filter(x => x.isActive && grade.commodityIds.includes(x.id))
            .map(OptionType.fromDataModel);

        return {
            id: grade.id,
            guid: grade.guid,
            code: grade.code,
            name: grade.name,
            commodities: commoditiesOptions,
            isActive: grade.isActive,
        };
    };

    public static createUpsert = (formValues : IGradeFormValues) : IGradeUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            commodityIds: formValues.commodities.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IGradeFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodities: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
